<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{'payment.new.DYN.' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <div class="warning-container mb_10" *ngIf="isOnlyMrz && params.prefill">
        <div class="flex">
          <fa-icon class="mr_5" size="xl" [icon]="'triangle-exclamation'"></fa-icon>
          <app-paragraph>{{'err.noCard' | translate}}</app-paragraph>
        </div>
      </div>
      <form id="form" [formGroup]="form" class="pt_20">
        <div>
          <app-input class="mb_30" icon="user" type="text" formCtrlName="LastName" [formGrp]="form" label="{{'form.lastName' | translate}}"></app-input>
          <app-input class="mb_30" icon="user" type="text" formCtrlName="FirstName" [formGrp]="form" label="{{'form.firstName' | translate}}"></app-input>
          <app-input class="mb_30" icon="passport" type="select" (output)="checkIfBorderPass()" formCtrlName="passportType" [formGrp]="form" label="{{'PassportType' | translate}}" [selectOptions]="passportTypeOptions"></app-input>
          <app-input class="mb_30" icon="hashtag" type="text" formCtrlName="passportNr" [formGrp]="form" label="{{'DYN.form.documentNumber.scanned' | translate: {document: scanDocument.documentCodeToName()} }}"></app-input>
          <app-input class="mb_30" icon="birthday-cake" type="date" formCtrlName="BirthDay" [formGrp]="form" label="{{'form.birthDate' | translate}}" [minDate]="birthDayValidator.minDate" [maxDate]="birthDayValidator.maxDate" [autoMinMaxDate]="true"></app-input>
          <app-input class="mb_30" icon="venus-mars" type="select" formCtrlName="gender" [formGrp]="form" label="{{'Gender' | translate}}" [selectOptions]="genderOptions"></app-input>
          <app-input class="mb_30" icon="user" type="select" formCtrlName="nationality" [formGrp]="form" label="{{'nationality.title' | translate}}" [selectOptions]="allNationalities" (output)="checkIfBorderPass()"></app-input>
          <app-input *ngIf="form.contains('existingValidEntryReferenceOfficer')" class="mb_30" icon="user" type="select" formCtrlName="existingValidEntryReferenceOfficer" [formGrp]="form" label="{{'form.existingValidEntryReferenceOfficer' | translate}}" [selectOptions]="officerOptions"></app-input>
            <ng-container *ngIf="params.prefill && this.params.prefill?.nationality === 'CHN'">
              <app-button size="xsm" class="fullWidth mb_10" (click)="changeToHKG()">{{ 'changeToHKG' | translate }}</app-button>
            </ng-container>
          <ng-container *ngIf="form.contains('borderPass')">
            <div class="mb_30">
              <lib-choice-button [formGrp]="form" formCtrlName="borderPass" [buttons]="choiceButtons" size="xsm" (output)="borderPassCheck($event)" [text]="('form.borderPass' | translate)"></lib-choice-button>
            </div>
          </ng-container>
          <ng-container *ngIf="form.contains('borderPassNumber')">
            <app-input class="mb_30" icon="hashtag" type="text" formCtrlName="borderPassNumber" [formGrp]="form" label="{{'form.borderPassNumber' | translate}}"></app-input>
          </ng-container>

          <ng-container *ngIf="form.contains('residentialAddress')">
            <app-input class="mb_30" icon="location-dot" type="text" formCtrlName="residentialAddress" [formGrp]="form" label="{{'form.residentialAddress' | translate}}"></app-input>
          </ng-container>

          <ng-container *ngIf="form.contains('issueDate')">
            <app-input class="mb_30" icon="calendar-days" type="date" formCtrlName="issueDate" [formGrp]="form" label="{{'form.issueDate' | translate}}"></app-input>
          </ng-container>

          <ng-container *ngIf="form.contains('expiryDate')">
            <app-input class="mb_30" icon="calendar-days" type="date" formCtrlName="expiryDate" [formGrp]="form" label="{{'form.expiryDate' | translate}}"></app-input>
          </ng-container>

          <ng-container *ngIf="form.contains('reason')">
            <app-input class="mb_30" icon="question-circle" type="text" formCtrlName="reason" [formGrp]="form" label="{{'form.reason' | translate}}"></app-input>
          </ng-container>

          <ng-container *ngIf="form.contains('authorizedCrossingPoints')">
            <app-input class="mb_30" icon="road-barrier" type="text" formCtrlName="authorizedCrossingPoints" [formGrp]="form" label="{{'form.authorizedCrossingPoints' | translate}}"></app-input>
          </ng-container>
        </div>
      </form>
      <div class="flex gap_10 f_align_c">
        <app-button size="xsm" color="transparent" border="true" type="button" [shortcut]="ShortcutAction.ESCAPE" [shortcutStyle]="{bottom: '-25px'}" (click)="nav.to(params.fromRoute || 'dashboard')" class="fullWidth resp_minSize_l">{{'global.back' | translate}}</app-button>
        <app-button size="xsm" formId="form" class="fullWidth resp_minSize_l" [shortcut]="ShortcutAction.ENTER" [shortcutStyle]="{bottom: '-25px'}" (click)="submitForm(false)">{{'exit.create' | translate}}</app-button>
      </div>
      <app-errors-list [dark]="true" *ngIf="submitted" [formErrors]="this.forms.getFormErrors(this.form)"></app-errors-list>
    </div>
  </div>
  <div class="f_align_end f_grow mb_20 resp_maxSize_l flex gap_5 mb_20">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
    <div>
      <app-button border="true" formId="form" class="fullWidth" (btnClicked)="nav.to(params.fromRoute || 'dashboard')"> <fa-icon icon="arrow-left"></fa-icon> </app-button>
    </div>
    <app-button type="button" (click)="submitForm(false)" class="fullWidth  resp_maxSize_l">{{'exit.create' | translate}}</app-button>
  </div>
</div>

<div id="webcamImage" class="loader_webcam" *ngIf="showFaceCheck">
    <img class="face-picture" [src]="borderPassPicture" alt="facePicture" [class.face-picture-sm]="showFaceCheck">
  <div class="webcam_btns f_center">
    <app-button size="xsm" color="red" [shortcut]="ShortcutAction.ESCAPE" (click)="goBack()">{{'global.close' | translate}}</app-button>
    <app-button size="xsm" color="red" [shortcut]="ShortcutAction.BACKSPACE" (click)="close()" [disabled]="submitted">{{'retake_picture' | translate}}</app-button>
    <app-button size="xsm" color="green" [shortcut]="ShortcutAction.ENTER" (click)="submitForm(fale)" [disabled]="submitted">{{'global.validate' | translate}}</app-button>
  </div>
</div>
<app-webcam [fullHeight]="true"
            *ngIf="!borderPassPicture && showCamera"
            (back)="goBack()"
            [backUrlParams]="backParams"
            (output)="setBorderPassPicture($event)"
            [imageQuality]="imageQuality"
            [videoOptions]="videoOptions"
            (emitManualProblem)="submitForm(true)"
            [brokenButton]="api.env.type === DocType.ZWEVISA ? true : false"
            [canRotateCamera]="true"
            (cameraProblem)="submitForm(true)">
</app-webcam>


